import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import { ListItemText } from "layouts/Flow Designer/components/Titlebar/components/TitlebarActions/StyledComponents";
import { WrapIcon } from "layouts/Flow Designer/components/Titlebar/components/TitlebarActions/StyledComponents";

export const WrapButton = ({ isWrapped, handleWrapResult }) => {
  return (
    <ListItem>
      <ListItemButton onClick={handleWrapResult}>
        <WrapIcon />
        <ListItemText
          primary={isWrapped ? "Unwrap" : "Wrap"}
          sx={{ alignItems: "center", display: "flex" }}
        />
      </ListItemButton>
    </ListItem>
  );
};
